import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIv_list } from '../../store';
import { addInverter } from '../../store'; // 추가한 액션 임포트
import { removeInverter } from '../../store'; // 삭제 액션
import config from '../../config';
import './IVSetting.css'

import axios from 'axios';


function IVSetting() {
  const dispatch = useDispatch();

  const settingList = useSelector((state) => state.settingList || {});
  const Iv_list = useSelector((state) => state.Iv_list || {});
  const ivData = useSelector((state) => state.ivData || {});
  console.log("ivData", ivData);




  const [inputcommPort, setcommPort] = useState('RS485-CH1');
  const [inputId, setInputId] = useState('1');
  const [inputName, setInputName] = useState('인버터1');
  const [inputProtocol, setInputProtocol] = useState('REMS-1');
  const [inputIP, setInputIP] = useState('192.168.105.101');
  const [inputPort, setInputPort] = useState('502');
  const [inputCapacity, setInputCapacity] = useState('100.000');
  const [inputPVstringNum, setInputPVstringNum] = useState('30');
  const [inputmpptNum, setInputmpptNum] = useState('15');
  const [isAutoUpdate, setIsAutoUpdate] = useState(true);
 

  const isRems = inputProtocol?.toLowerCase() === 'rems-1' || inputProtocol?.toLowerCase() === 'rems-3';

  //스트링 개수만큼 체크 표시 
  useEffect(() => {
  if (!isAutoUpdate) return; // 수동 체크면 무시

  const count = Number(inputPVstringNum);
  if (!isNaN(count) && count >= 0 && count <= 32) {
    const newChecked = Array(32).fill(0).map((_, i) => (i < count ? 1 : 0));
    setInputchUsed(newChecked);
  }
}, [inputPVstringNum, isAutoUpdate]);

  const defaultChannelNames = 'CH1,CH2,CH3,CH4,CH5,CH6,CH7,CH8,CH9,CH10,CH11,CH12,CH13,CH14,CH15,CH16,CH17,CH18,CH19,CH20,CH21,CH22,CH23,CH24,CH25,CH26,CH27,CH28,CH29,CH30'.split(',');
  const defaultCheckedChannels = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1'.split(',').map(Number);
  
  const [inputchName, setInputchName] = useState([...defaultChannelNames]);
  const [inputchUsed, setInputchUsed] = useState([...defaultCheckedChannels]);

  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null); 
  const [isEditing, setIsEditing] = useState(false);

  
  const {
    iv_protocolList = [],
    commPortList = [],
  } = settingList;


  
  const handleCapacityChange = (e) => {
    let value = e.target.value;
    if (value.includes('.')) {
      const parts = value.split('.');
      if (parts[1].length > 2) {
        value = `${parts[0]}.${parts[1].slice(0, 2)}`;
      }
    }
    setInputCapacity(value);
  };

    // 최초 장비 리스트 불러오기
    useEffect(() => {
      dispatch(fetchIv_list());
    }, [dispatch]);


  const ivAddclick = async () => {
    const nextId = (parseInt(inputId) + 1).toString();
    const nextName = `${inputName.split(/[0-9]+$/)[0]}${nextId}`;

    const defaultChannelNames = 'CH1,CH2,CH3,CH4,CH5,CH6,CH7,CH8,CH9,CH10,CH11,CH12,CH13,CH14,CH15,CH16,CH17,CH18,CH19,CH20,CH21,CH22,CH23,CH24,CH25,CH26,CH27,CH28,CH29,CH30';
    const defaultChannelUsage = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1';

    const newInverter = {
      name: inputName,
      protocol: inputProtocol,
      capacity: parseFloat(inputCapacity).toFixed(3),
      commPort: inputcommPort,
      id: inputId,
      ip: inputcommPort === 'ETHERNET' ? inputIP : '192.168.0.101', // 이더넷일 때만 IP 설정
      port: inputcommPort === 'ETHERNET' ? inputPort : null, // 이더넷일 때만 포트 설정, 아닐 때는 null
      PVstringNum: inputPVstringNum,
      mpptNum: inputmpptNum,
      chName: defaultChannelNames,
      chUsed: defaultChannelUsage,
    };

    try {
      const response = await axios.post(`${config.backendUrl}/api/inverters`, newInverter);
      if (response.status === 201) {
        // console.log('Inverter added successfully:', response.data);

        //--- db에서 인버터 리스트를 읽어 다시 갱신 [seq값을 불러오기위해 어쩔수 없음]
        dispatch(fetchIv_list());
        // Redux 상태 업데이트
        dispatch(addInverter(newInverter)); // 여기서 dispatch를 사용

        if (!isEditing) {
          setInputId(nextId);
          setInputName(nextName);
          // IP 자동 증가 제거: 입력값 유지
          setInputIP(inputIP);
          setInputPort('502');
          setInputCapacity('100.000');
          setInputPVstringNum('30');
          setInputmpptNum('15');
        }
      } else {
        console.error('Failed to add inverter:', response);
      }
    } catch (error) {
      console.error('An error occurred while adding inverter:', error);
    }

    if (isEditing) {
      handleSaveClick();
    }
  };

  const handleEditClick = (port, index) => {
    // Iv_list 객체 내부 데이터 존재 여부 확인
    if (!Iv_list || !Iv_list.iv_commPort || !Iv_list.iv_commPort[index]) {
      console.error('Invalid Iv_list data at port:', port, 'index:', index);
      return;
    }
  
    let inverter = {};
  
    // 포트가 'ETHERNET'인 경우에만 IP와 Port 값을 추가로 가져옴
    if (Iv_list.iv_commPort[index] === 'ETHERNET') {
      inverter = {
        id: Iv_list.iv_address[index] || '',  // 인버터의 ID
        name: Iv_list.iv_name[index] || '',   // 인버터의 이름
        protocol: Iv_list.iv_protocol[index] || '',  // 프로토콜
        ip: Iv_list.iv_ethernetIp && Iv_list.iv_ethernetIp[index] ? Iv_list.iv_ethernetIp[index] : '192.168.105.101',  // ip 확인
        port: Iv_list.iv_ethernetPort && Iv_list.iv_ethernetPort[index] ? Iv_list.iv_ethernetPort[index] : '502',  // port 확인
        capacity: Iv_list.iv_capa[index] || '0.000',  // 용량
        PVstringNum: Iv_list.iv_number_of_PVstrings_per_MPPT[index] || '30',  
        mpptNum: Iv_list.iv_number_of_mppt[index] || '15',
      };
    } else {
      // 'ETHERNET'이 아닌 경우에는 IP와 Port를 빈 문자열로 설정
      inverter = {
        id: Iv_list.iv_address[index] || '',  // 인버터의 ID
        name: Iv_list.iv_name[index] || '',   // 인버터의 이름
        protocol: Iv_list.iv_protocol[index] || '',  // 프로토콜
        ip: '',  // 비어 있음
        port: '',  // 비어 있음
        capacity: Iv_list.iv_capa[index] || '0.000',  // 용량
        PVstringNum: Iv_list.iv_number_of_PVstrings_per_MPPT[index] || '30',  
        mpptNum: Iv_list.iv_number_of_mppt[index] || '15',
      };
    }
  
    // 상태 업데이트
    setEditIndex(index);
    setcommPort(Iv_list.iv_commPort[index]);
    setInputId(inverter.id);
    setInputName(inverter.name);
    setInputProtocol(inverter.protocol);
    setInputIP(inverter.ip || '192.168.105.101');
    setInputPort(inverter.port || '502');
    setInputCapacity(inverter.capacity);
    setInputPVstringNum(inverter.PVstringNum);
    setInputmpptNum(inverter.mpptNum);

    // 채널 이름과 사용 여부
    const rawNames = Iv_list.iv_pv_ch_name?.[index];
    const rawUsed = Iv_list.iv_pv_ch_use?.[index];

    // 이미 사용자가 수정한 값이 존재하고, 30개 이상이면 그걸 유지
    const currentNamesValid = inputchName?.length === 30;
    const currentUsedValid = inputchUsed?.length === 30;

    const channelNamesData = currentNamesValid
      ? inputchName
      : (rawNames?.split(',').length >= 30 ? rawNames.split(',') : [...defaultChannelNames]);

    const checkedChannelsData = currentUsedValid
      ? inputchUsed
      : (rawUsed?.split(',').length >= 30 ? rawUsed.split(',').map(Number) : [...defaultCheckedChannels]);


    setInputchName(channelNamesData);
    setInputchUsed(checkedChannelsData);
  
    // 모달을 열기
    setIsEditing(true);
    setShowModal(true);
  };

  // 채널 사용 여부 체크박스 처리
  const handleChannelCheck = (index) => {
    const newCheckedChannels = [...inputchUsed];
    newCheckedChannels[index] = newCheckedChannels[index] === 1 ? 0 : 1;

    const checkedCount = newCheckedChannels.filter((v) => v === 1).length;

    setIsAutoUpdate(false); // 사용자 직접 조작이므로 autoUpdate 방지
    setInputchUsed(newCheckedChannels);
    setInputPVstringNum(String(checkedCount));
  };
  
  const handlePVStringNumChange = (e) => {
    setIsAutoUpdate(true); // 사용자가 직접 입력한 거니까 자동 체크 허용
    setInputPVstringNum(e.target.value);
  };

  const handleSaveClick = async () => {
    const updatedInverter = {
      id: inputId,  
      name: inputName,
      protocol: inputProtocol,
      ip: inputcommPort === 'ETHERNET' ? inputIP : Iv_list.iv_ethernetIp[editIndex] || '',
      port: inputcommPort === 'ETHERNET' ? inputPort : Iv_list.iv_ethernetPort[editIndex] || '',
      capacity: parseFloat(inputCapacity).toFixed(3),
      commPort: inputcommPort,
      PVstringNum: inputPVstringNum,
      mpptNum: inputmpptNum,
      chName: inputchName.join(','),
      chUsed: inputchUsed.join(','),
    };
  
    const seq = Iv_list.seq[editIndex];
  
    try {
      const response = await axios.put(`${config.backendUrl}/api/update_inverter/${seq}`, updatedInverter);
      if (response.status === 200) {
        // console.log('Inverter updated successfully:', response.data);
        dispatch(fetchIv_list()); // 변경 사항 반영
      } else {
        console.error('Failed to update inverter:', response);
      }
    } catch (error) {
      console.error('An error occurred while updating inverter:', error);
    }
  
    setIsEditing(false);
    setShowModal(false);
  };
  
  
  



  const handleDeleteClick = (port, index) => {
    if (Iv_list.iv_commPort[index] === port) {
      const confirmDelete = window.confirm(Iv_list.iv_name[index] + '을정말로 삭제하시겠습니까? 삭제후 다시는 데이터를 복원할수 없습니다.');
      if (confirmDelete) {
        axios
          .delete(`${config.backendUrl}/api/inverters/${Iv_list.seq[index]}`)
          .then((response) => {
            // 삭제가 성공한 후에 리덕스 스토어에서 인버터를 제거하는 액션 디스패치
            dispatch(removeInverter({ port, index }));
            window.alert(Iv_list.iv_name[index] + ' : 삭제 완료');
          })
          .catch((error) => {
            console.error('삭제 중 오류 발생:', error);
          });
      }
    } else {
      console.error('Invalid index or port:', port, index);
    }
  };
  
  

  const handleRowClick = (commPort) => {
    let url = '';

    // 각 iv_commPort에 따라 URL을 설정
    switch (commPort) {
      case 'RS485-CH1':
        url = `${config.backendUrl}/RS485-CH1`;
        break;
      case 'RS485-CH2':
        url = `${config.backendUrl}/RS485-CH2`;
        break;
      case 'RS485-CH3':
        url = `${config.backendUrl}/RS485-CH3`;
        break;
      case 'ETHERNET':
        url = `${config.backendUrl}/ETHERNET`;
        break;
      default:
        return; // 아무것도 하지 않음
    }

    // URL을 새 창으로 열기
    window.open(url, '_blank');
  };
  


  return (


    <Container className="mt-5">

      {/* <div>
        {Iv_list.iv_commPort.map((commPort, index) => (
          <div key={index}>
            {commPort}
          </div>
        ))}
      </div>

      <div>
        {Iv_list.iv_name.map((iv_name, index) => (
          <div key={index}>
            {iv_name}
          </div>
        ))}
      </div> */}

      <Row className="align-items-center justify-content-center mb-3">
        <Col md="2">
          <Form.Label className="text-center w-100">통신 포트</Form.Label>
          <Form.Control
            as="select"
            value={inputcommPort}
            onChange={(e) => setcommPort(e.target.value)}
            className="text-center"
          >
            {commPortList.map((port, index) => (
              <option key={index} value={port}>
                {port}
              </option>
            ))}
          </Form.Control>
        </Col>
        {inputcommPort === 'ETHERNET' && (
          <>
            <Col md="2">
              <Form.Label className="text-center w-100">IP 주소</Form.Label>
              <Form.Control
                type="text"
                value={inputIP}
                onChange={(e) => setInputIP(e.target.value)}
                className="text-center"
                placeholder="192.168.0.101"
              />
            </Col>
            <Col md="1">
              <Form.Label className="text-center w-100">포트</Form.Label>
              <Form.Control
                type="text"
                value={inputPort}
                onChange={(e) => setInputPort(e.target.value)}
                className="text-center"
                placeholder="502"
              />
            </Col>
          </>
        )}
        <Col md="1">
          <Form.Label className="text-center w-100">장비 ID</Form.Label>
          <Form.Control
            type="text"
            value={inputId}
            onChange={(e) => setInputId(e.target.value)}
            className="text-center"
          />
        </Col>
        <Col md="2">
          <Form.Label className="text-center w-100">인버터 이름</Form.Label>
          <Form.Control
            type="text"
            value={inputName}
            onChange={(e) => setInputName(e.target.value)}
            className="text-center"
          />
        </Col>
        <Col md="2">
          <Form.Label className="text-center w-100">프로토콜 선택</Form.Label>
          <Form.Control
            as="select"
            value={inputProtocol}
            onChange={(e) => setInputProtocol(e.target.value)}
            className="text-center"
          >
            {iv_protocolList.map((protocol, index) => (
              <option key={index} value={protocol}>
                {protocol}
              </option>
            ))}
          </Form.Control>
        </Col>
        {!isRems && (
            <>
                <Col md="2">
                <Form.Label className="text-center w-100">MPPT 개수</Form.Label>
                <Form.Control
                    type="text"
                    value={inputmpptNum}
                    onChange={(e) => setInputmpptNum(e.target.value)}
                    className="text-center"
                />
                </Col>
                <Col md="2">
                <Form.Label className="text-center w-100">스트링 개수</Form.Label>
                <Form.Control
                    type="text"
                    value={inputPVstringNum}
                    onChange={(e) => setInputPVstringNum(e.target.value)}
                    className="text-center"
                />
                </Col>
            </>
        )}
        <Col md="1">
          <Form.Label className="text-center w-100">용량 (kW)</Form.Label>
          <Form.Control
            type="text"
            value={inputCapacity}
            onChange={handleCapacityChange}
            className="text-center"
            placeholder="100.00"
          />
        </Col>
        <Col md="2" className="text-center">
          <Button variant="info" onClick={ivAddclick} className="mt-4 w-100">
            인버터 추가
          </Button>
        </Col>
      </Row>


      {/* 1. 저장된 통신포트 갯수 만큼 map반복
      2. 처음부터 RS485-1번만 계속 반복 [중간에 RS485-2가 나오면 건너뜀]
      3. 전체 반복했으면 RS485-2 반복 이때 테이블은 새롭게 시작 
      4. 마찬가지로 마지막 ethernet까지 반복함 이때도 테이블은 새롭게 시작 
      5. 통신 포트 이름은 DB에 가져온걸로 검색되어야함
      6. 각행은 통신포트검색될때의 index값으로 뿌림 [인버터이름 프로토콜 등등]
      7. ethernet으로 검색되면 ip 주소 및 포트도 같이 보이도록  */}

      {Array.from(new Set(Iv_list.iv_commPort)).map((port) => (
        <div key={port}>
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th onClick={() => handleRowClick(port)} style={{ cursor: 'pointer' }}>{port}</th>
                <th>장비 ID</th>
                <th>인버터 이름</th>
                <th>프로토콜</th>
                {port === 'ETHERNET' && (
                  <>
                    <th>IP 주소</th>
                    <th>포트</th>
                  </>
                )}
                <th>MPPT 개수</th>
                <th>스트링 개수</th>
                <th>용량</th>
                <th>송신</th>
                <th>수신</th>
                <th>수정</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              {Iv_list.iv_commPort.map((commPort, index) => {
                if (commPort === port) {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{Iv_list.iv_commPort[index]}</td>
                      <td>{Iv_list.iv_address[index]}</td>
                      <td>{Iv_list.iv_name[index]}</td>
                      <td>{Iv_list.iv_protocol[index]}</td>
                      {port === 'ETHERNET' && (
                        <>
                          <td>{Iv_list.iv_ethernetIp && Iv_list.iv_ethernetIp[index]}</td>
                          <td>{Iv_list.iv_ethernetPort && Iv_list.iv_ethernetPort[index]}</td>
                        </>
                      )}
                      {['rems-1', 'rems-3'].includes(Iv_list.iv_protocol[index]?.toLowerCase()) ? (
                        <>
                            <td>-</td>
                            <td>-</td>
                        </>
                        ) : (
                        <>
                            <td>{Iv_list.iv_number_of_mppt[index]}</td>
                            <td>{Iv_list.iv_number_of_PVstrings_per_MPPT[index]}</td>
                        </>
                        )}
                      <td>{Iv_list.iv_capa[index]}</td>
                      <td>{ivData.sendCount[index]}</td>
                      <td>{ivData.receiveCount[index]}</td>
                      <td>
                        <Button
                          variant="warning"
                          style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                          onClick={() => handleEditClick(port, index)}
                        >
                          수정
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="danger"
                          style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                          onClick={() => handleDeleteClick(port, index)}
                        >
                          삭제
                        </Button>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </Table>
        </div>
      ))}

       <Modal show={showModal} onHide={() => setShowModal(false)} className="custom-modal" size="xl">
        <Modal.Header closeButton>
          <Modal.Title>인버터 수정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col  style={{ width: '200px' }}>
                <Form.Group>
                  <Form.Label>통신 포트</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputcommPort}
                    onChange={(e) => setcommPort(e.target.value)}
                  >
                    {commPortList.map((port, index) => (
                      <option key={index} value={port}>
                        {port}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {inputcommPort === 'ETHERNET' && (
                  <>
                    <Form.Group>
                      <Form.Label>IP 주소</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputIP}
                        onChange={(e) => setInputIP(e.target.value)}
                        placeholder="192.168.0.101"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>포트</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputPort}
                        onChange={(e) => setInputPort(e.target.value)}
                        placeholder="502"
                      />
                    </Form.Group>
                  </>
                )}

                <Form.Group>
                  <Form.Label>장비ID(어드레스)</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputId}
                    onChange={(e) => setInputId(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>인버터 이름</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputName}
                    onChange={(e) => setInputName(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>프로토콜 선택</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputProtocol}
                    onChange={(e) => setInputProtocol(e.target.value)}
                  >
                    {iv_protocolList.map((protocol, index) => (
                      <option key={index} value={protocol}>
                        {protocol}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {!isRems && (
                  <>
                    <Form.Group>
                      <Form.Label>MPPT 개수</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputmpptNum}
                        onChange={(e) => setInputmpptNum(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>스트링 개수</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputPVstringNum}
                        onChange={(e) => setInputPVstringNum(e.target.value)}
                      />
                    </Form.Group>
                  </>
                )}

                <Form.Group>
                  <Form.Label>용량 (kW)</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputCapacity}
                    onChange={handleCapacityChange}
                    placeholder="100.00"
                  />
                </Form.Group>
              </Col>

              <Col  style={{ width: '600px', marginTop: '32px' }}>
                {!isRems && (
                  <Row className="flex-wrap">
                    {inputchName.map((name, index) => (
                      <Col key={index} md={6} className="mb-2 d-flex align-items-center">
                        <span style={{ width: '20px' }}>{index + 1}</span>
                        <Form.Control
                          type="text"
                          value={name}
                          onChange={(e) => {
                            const newChannelNames = [...inputchName];
                            newChannelNames[index] = e.target.value;
                            setInputchName(newChannelNames);
                          }}
                          className="mx-1"
                          style={{ fontSize: '12px', padding: '4px' }}
                        />
                        <Form.Check
                          type="checkbox"
                          checked={inputchUsed[index]}
                          onChange={() => handleChannelCheck(index)}
                          style={{ transform: 'scale(1.0)' }}
                        />
                      </Col>
                    ))}
                  </Row>
                )}
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            저장
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default IVSetting;
